/* eslint-disable multiline-ternary */
/* eslint-disable no-unused-expressions */
/* eslint-disable indent */
import React from 'react'
import { View, Text, Font, StyleSheet, Image } from '@react-pdf/renderer'
import { PropTypes } from 'prop-types'

import { themeConfig } from '../../config/theme.config'
import {
  PEDESTRIAN,
  BICYCLE,
  AUTO,
  TRANSIT,
  FREIGHT
} from '../../constants/modalTiers'
import SectionTitle from './SectionTitle'
import getRating from '../../utils/getRating'
import {
  MAIN_STREET,
  URBAN_OR_WALKABLE_THOROUGHFARE,
  SMALL_TOWN_HAMLET_OR_VILLAGE_COMMERCIAL,
  SUBURBAN_CORRIDORS,
  RURAL
} from '../../config/segments.config'

const ScoringModal = ({
  name,
  tierId,
  avgScore = '',
  modalTier,
  priority,
  weakestLinkScore = '',
  landUseContext = '',
  reportPedestrialImgUrl,
  reportBicycleImgUrl,
  reportAutoImgUrl,
  reportTransitImgUrl,
  reportFreightImgUrl
}) => {
  const container = {
    display: 'flex',
    justifyContent: 'space-around',

    alignContent: 'space-around',
    flexDirection: 'row',
    padding: '10pt',
    height: 290
  }
  const text = {
    fontSize: 10,

    alignSelf: 'center',
    fontFamily: 'Roboto'
  }
  const scoreText = {
    fontSize: 20,
    fontWeight: 'bold',
    fontFamily: 'Roboto',
    alignSelf: 'center'
  }
  function getImg() {
    switch (name) {
      case PEDESTRIAN:
        return reportPedestrialImgUrl

      case BICYCLE:
        return reportBicycleImgUrl

      case TRANSIT:
        return reportTransitImgUrl
      case AUTO:
        return reportAutoImgUrl
      case FREIGHT:
        return reportFreightImgUrl
      default:
        return null
    }
  }

  const score = avgScore === 0 || avgScore ? avgScore : weakestLinkScore
  const rating = getRating(score)

  function getColor() {
    return rating === 'Good'
      ? '#4C8C44'
      : rating === 'Okay'
      ? '#f5c71a'
      : rating === 'Improve'
      ? '#e52b50'
      : '#757575'
  }

  function getObjectiveMet(avgScore) {
    switch (landUseContext) {
      case MAIN_STREET:
        return avgScore > 0 && avgScore < 3

      case URBAN_OR_WALKABLE_THOROUGHFARE:
        return avgScore > 0 && avgScore < 3

      case SMALL_TOWN_HAMLET_OR_VILLAGE_COMMERCIAL:
        return avgScore > 0 && avgScore < 3

      case SUBURBAN_CORRIDORS:
        return avgScore > 0 && avgScore < 3

      case RURAL:
        return avgScore > 0 && avgScore < 4

      default:
    }
  }

  return (
    <View
      style={{
        display: 'flex',
        justifyItems: 'space-between',
        // justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '5pt',
        fontFamily: 'Roboto',
        width: '20%',
        maxWidth: '20%'
      }}
    >
      <Text style={[text]} wrap={true}>
        Priority: {priority}
      </Text>
      {getImg && (
        <Image
          src={getImg}
          style={{
            height: 40,
            width: 40,
            objectFit: 'contain',
            alignSelf: 'center'
          }}
        />
      )}

      <Text style={[scoreText, { color: getColor() }]}>{score}</Text>
      <Text
        style={
          ([text],
          {
            color: getColor(),
            fontSize: 10,
            fontFamily: 'Roboto',
            fontWeight: 'bold'
          })
        }
      >
        {rating}
      </Text>
      <Text style={[text, { fontStyle: 'italic' }]} wrap={true}>
        Modal Tier:
      </Text>
      <Text style={[text, { fontStyle: 'italic' }]} wrap={true}>
        {modalTier !== 0 ? modalTier : 'None'}
      </Text>
      {landUseContext && (
        <Text style={[text, { fontStyle: 'italic' }]} wrap={true}>
          Objective Met:
        </Text>
      )}
      {landUseContext && (
        <View style={[text]} wrap={true}>
          {getObjectiveMet(score) ? (
            <Text
              style={{
                fontSize: 10,
                color: 'green',
                fontFamily: 'Roboto',
                fontWeight: 'bold'
              }}
            >
              YES
            </Text>
          ) : (
            <Text
              style={{
                fontSize: 10,
                color: 'red',
                fontFamily: 'Roboto',
                fontWeight: 'bold'
              }}
            >
              NO
            </Text>
          )}
        </View>
      )}
    </View>
  )
}

export default ScoringModal

ScoringModal.propTypes = {
  name: PropTypes.string,
  tierId: PropTypes.string,
  avgScore: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  modalTier: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  priority: PropTypes.string,
  weakestLinkScore: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  landUseContext: PropTypes.string,
  reportPedestrialImgUrl: PropTypes.string,
  reportBicycleImgUrl: PropTypes.string,
  reportAutoImgUrl: PropTypes.string,
  reportTransitImgUrl: PropTypes.string,
  reportFreightImgUrl: PropTypes.string
}
